<template>
    <div :class="css.container">
        <search-gene-modal ref="modal" :selector="selector" @change="methods.change" />
        <ui-form :class="css.body" :data="data">
            <ui-form-item :class="css.row">
                <div :class="css.name">{{ $t("GeneName") }}</div>
                <default-search v-model="data.name" :disabled="disabled" v-bind="binds.name" @search="modal?.open(data.name)" />
            </ui-form-item>

            <ui-form-item :class="css.row">
                <div :class="css.name">{{ $t("TranscriptID") }}</div>
                <ui-select
                    v-model="data.transcript_id"
                    width="100%"
                    :disabled="disabled"
                    :candidates="candidates"
                    :placeholder="$t('PleaseEnterTranscript')" />
            </ui-form-item>

            <ui-form-item :class="css.row">
                <div :class="css.name">{{ $t("Mutation") }}</div>
                <ui-input v-model="data.mutation" :disabled="disabled" width="100%" />
            </ui-form-item>
        </ui-form>

        <div :class="css.error" v-if="error">{{ error }}</div>

        <ui-button :class="css.submit" :disabled="status" size="small" @click="methods.submit"> {{ $t("Submit") }} </ui-button>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiForm, UiInput, UiButton, UiSelect, UiFormItem } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
import { SearchGeneModal } from "@/components/windows";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const emits = defineEmits(["submit"]);
const define = defineProps(ModulePropsOption);

//* 组合函数
const { refs, data, nodes, binds, methods, computeds } = useComposable(define, emits);
const { error, candidates } = refs;
const { modal } = nodes;
const { status, selector } = computeds;

//* 初始化
methods.init();
</script>
